import { type FieldValues, type UseFormRegister } from "react-hook-form";
import { FormSectionFormFieldsNote } from "~/__generated__/graphql";
import RichText from "../RichText";

export default function Checkbox({ note }: FormSectionFormFieldsNote) {
  return <RichText field={note ?? ""} className="text-white opacity-40" />;
}
